<list-users-composition class="full-height" [gotoUserDetail]="true" [actionEvents]="actions" (doAction)="onDoAction($event)" paddingBottom="true">
  <simple-header title="Usuarios" [back]="true" icon="close"></simple-header>
  <button fab [allowAction]="['users.create']" mat-fab color="primary" class="fab-button" [routerLink]="['/app/list-users/create']">+</button>
</list-users-composition>
